export default "__VITE_ASSET__C2$Au156__"